import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../resources/css/common.css";
import "../../resources/css/layout.css";
import ScrollAnimation from "../../resources/js/ScrollAnimation.js";
import Header from "../Header/Header.jsx";
import Footer from "../Footer/Footer.jsx";

const Manager = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 | 아소비 지사장`;

    // 페이지 뷰 추적
    window.gtag("config", "G-LYT78YCDYK", {
      page_path: location.pathname,
    });

    // IP 체크 함수
    const checkIP = async () => {
      const response = await fetch("/check-ip");
      const result = await response.json();

      // 리다이렉션 확인
      if (result.redirect) {
        navigate(result.redirect); // navigate로 리다이렉션
      }
    };

    checkIP(); // IP 체크 함수 호출
  }, [location, navigate]); // navigate 추가

  return (
    <div>
      <Header>
        <div className="header-down">
          <div className="wrap">
            <ul>
              <li>
                <a href="/startUp">아소비 창업</a>
              </li>
              <li>
                <a href="/startInfo">창업 안내</a>
              </li>
              <li>
                <a href="/startProcess">창업 절차</a>
              </li>
              <li>
                <a href="/benefit">지원 혜택</a>
              </li>
              <li>
                <a href="/asobimanager" className="sel">
                  아소비 지사장
                </a>
              </li>
            </ul>
          </div>
        </div>
      </Header>
      <ScrollAnimation />
      <section id="container">
        <div className="subvisual">
          <div className="title"> 아소비 창업</div>
          <div className="text">
            꾸준히 늘어나는 가맹으로 증명하는 아소비 창업! <br />
            아소비에 대해 알아보고 당신도 성공하는 창업자가 되어 보세요.{" "}
          </div>
          <div className="image">
            <img src="../custom-resources/img/sub_startup_bg.png" alt="" />
          </div>
        </div>
        <div className="breadcrumb">
          <div className="wrap">
            <div className="loca">
              <span>
                <img src="../custom-resources/img/icon_home.png" alt="" />
              </span>
              <span className="on">아소비 창업</span>
            </div>
            <div className="menu">
              <a href="/startInfo">창업 안내</a>
              <a href="/startProcess">창업 절차</a>
              <a href="/benefit">지원 혜택</a>
              <a href="/asobimanager" className="on">
                아소비 지사장
              </a>
            </div>
          </div>
        </div>
        <div className="manager">
          <div className="sect manager01">
            <div className="wrap">
              <div className="tit init">
                <span>
                  <p>올바른 교육의 가치로</p>
                </span>
                <span>
                  <p>아소비를 이끄는 힘</p>
                </span>
              </div>
              <div className="txt init">
                본사와 지사장님이 영업지역의 계약을 통해 담당 지역 내 교육원
                개설 및 관리를 하고 <br />
                많은 교육원이 아소비의 가치를 잘 실현할 수 있도록 노력하고
                있습니다.
              </div>
              <div className="img init">
                <img
                  src="../custom-resources/img/img_manager_manager01_img.png"
                  alt=""
                />
                <img
                  src="../custom-resources/img/img_manager_manager01_img_after.png"
                  className="animg"
                  alt=""
                />
                <img
                  src="../custom-resources/img/img_manager_manager01_img_after2.png"
                  className="animg"
                  alt=""
                />
                <img
                  src="../custom-resources/img/img_manager_manager01_img_after3.png"
                  className="animg"
                  alt=""
                />
                <img
                  src="../custom-resources/img/img_manager_manager01_img_after4.png"
                  className="animg"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="sect manager02">
            <div className="wrap">
              <div className="tit init">
                <em>아소비 지사장은요?</em>
                삶의 워라밸이 가능한 사업
              </div>
              <div className="txt init">
                <p>
                  내 일이 즐겁고 내일이 기대되는 <br className="mo-view" />{" "}
                  아소비 지사장
                </p>
                <p>
                  퇴근 후 가족과 함께하는 여유를 즐기는{" "}
                  <br className="mo-view" /> 아소비 지사장
                </p>
                <p>
                  독립적인 본인의 사업이 가능한 <br className="mo-view" />{" "}
                  아소비 지사장
                </p>
                <p>
                  열정과 역량만큼의 성과급을 <br className="mo-view" /> 꿈꿀 수
                  있는 아소비 지사장
                </p>
              </div>
            </div>
          </div>
          <div className="sect manager03">
            <div className="wrap">
              <div className="tit init">지사장님 채용 절차</div>
              <div className="lst init">
                <ul>
                  <li>
                    <p>서류 전형</p>
                  </li>
                  <li>
                    <p>본사 면접</p>
                  </li>
                  <li>
                    <p>최종 합격</p>
                  </li>
                  <li>
                    <p>지사장 교육</p>
                  </li>
                  <li>
                    <p>지사 개설</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="sect manager04">
            <div className="wrap">
              <div className="tit init">
                미 개설 지사 모집
                <em></em>
              </div>
              <div className="tbl init">
                <table>
                  <thead>
                    <tr>
                      <th>지역</th>
                      <th>지사</th>
                      <th>영업지역</th>
                      {/* <!-- th>개설비용(VAT 별도)</th --> */}
                      <th>진행현황</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>강원도</td>
                      <td>강원영동지사</td>
                      <td>강릉시/동해시/삼척시</td>
                      {/* <!--td>17,000,000</td --> */}
                      {/* <td style="color:#1a478c"></td> */}
                    </tr>
                    <tr>
                      <td>경상북도</td>
                      <td>안동영주예천지사</td>
                      <td>안동시/영주시/예천군</td>
                      {/* <!--td>20,000,000</td --> */}
                      {/* <td style="color:#1a478c"></td> */}
                    </tr>
                    <tr>
                      <td>전라남도</td>
                      <td>여수순천광양지사</td>
                      <td>여수시/순천시/광양시</td>
                      {/* <!--td>20,000,000</td --> */}
                      <td></td>
                    </tr>

                    {/* <!--tr>
									<td rowspan='2'>대구광역시</td>
                                    <td>대구남수성구지사</td>
                                    <td>남구/수성구</td>
                                    <td>22,000,000</td>
                                    <td>개설 완료</td>
                                </tr-->> */}
                    {/* <!--tr>								
                                    <td>대구중서칠곡지사</td>
                                    <td>대구중구/서구/칠곡군</td>
                                    <td>25,000,000</td>
                                    <td>개설 완료</td>
                                </tr--> */}
                    <tr>
                      <td rowspan="3">서울특별시</td>
                      <td>서울중부지사</td>
                      <td>중구/용산구/종로구/영등포구</td>
                      {/* <!--td>25,000,000</td --> */}
                      <td></td>
                    </tr>
                    <tr>
                      <td>서초강남지사</td>
                      <td>서초구/강남구</td>
                      {/* <!--td>25,000,000</td --> */}
                      <td></td>
                    </tr>
                    <tr>
                      <td>은평서대문마포지사 </td>
                      <td>은평구/서대문구/마포구</td>
                      {/* <!--td>25,000,000</td --> */}
                      <td></td>
                    </tr>
                    {/* <!-- tr>
									<td rowspan='2'>전라남도</td>
									<td>목포나주지사</td>
                                    <td>목포시/나주시/무안군</td>
                                    <td>16,000,000</td>
                                    <td style="color:#1a478c">상담중</td>
                                </tr>					
								<tr>
                                    <td>여수순천광양지사</td>
                                    <td>여수시/순천시/광양시</td>
                                    <td>21,000,000</td>
                                    <td style="color:#1a478c">상담중</td>
                                </tr>
								<tr>
									<td>충청북도</td>
                                    <td>충주제천지사</td>
                                    <td>충주시/제천시/음성군</td>
                                    <td>25,000,000</td>
                                    <td style="color:#1a478c"></td>
                                </tr --> */}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="sect manager05">
            <div className="wrap">
              <div className="tit init">지사 개설 문의</div>
              <div className="txt init">
                탄탄한 기반을 잡고 나아가고 있는 아소비에서 <br />
                함께 할 신규 지사장님을 모집하오니 많은 지원 부탁드립니다.
              </div>
              <div className="dow init">
                <a href="../DATA/upload/아소비_지사장_이력서.hwp">
                  지원양식 다운로드
                </a>
              </div>
              <div className="contact init">
                <p>개설 전화 상담 : 070-5211-1452</p>
                <p>이력서 제출 : kyumin.kim@asobi.co.kr</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Manager;
